export default __webpack_public_path__ + "static/media/auth-bg.8a6ccc22.png";